// Let a screen take the phone's BACK key for a step INSIDE itself (2026-10-18).
//
// The hardware back key is one global handler (App.jsx HardwareBack) that walks
// the route structure. A screen with inner steps on ONE route — BLE Test: scan
// list → connected device / install mode — was left behind by it: back from a
// connected device left BLE Test altogether and the scan list was gone (owner:
// "back should return to the same page it went inside from").
//
// A screen registers a handler while mounted; HardwareBack asks the newest one
// first. Returning `true` means "handled — do not navigate"; `false` lets the
// normal structural back run.

const handlers = [];

/** -> remove() */
export function interceptBack(fn) {
  handlers.push(fn);
  return () => {
    const i = handlers.lastIndexOf(fn);
    if (i >= 0) handlers.splice(i, 1);
  };
}

/** -> true when a screen handled the press. */
export function runBackIntercept() {
  for (let i = handlers.length - 1; i >= 0; i -= 1) {
    try {
      if (handlers[i]()) return true;
    } catch (e) { /* a broken handler must not trap the user */ }
  }
  return false;
}
